// components/SubscribeModal.js
"use client";
import ModalWrapper from "./ModalWrapper";
import {
  Grid,
  Button,
  Form,
  Loader,
  GridRow,
  GridColumn,
} from "semantic-ui-react";
import { FormError } from "../../../components/index.js";

export default function SubscribeModal({
  subscribemodal,
  closesubscribemodal,
  customStyles,
  SubscribtionModalSubmit,
  subscribeemail,
  handlesubscribeemailChange,
  subscribeemailstatus,
  subscribe_err_msg,
  subscribe_success_msg,
  isLoading,
  page,
}) {
  return (
    <ModalWrapper
      isOpen={subscribemodal}
      onRequestClose={closesubscribemodal}
      style={customStyles}
      contentLabel="Subscribe Modal"
    >
      {/* Close Button */}
      <div className="slider_modal_btn_track">
        <span
          onClick={closesubscribemodal}
          data-primary={true}
          style={{ marginTop: "10px" }}
        >
          X
        </span>
      </div>

      <Form onSubmit={SubscribtionModalSubmit} style={{ width: "97%" }}>
        <Grid className="modal_grid">
          <GridRow>
            <GridColumn mobile={16} tablet={16} computer={16}>
              {/* Title + Description */}
              <div className="track_modal">
                <p className="modal_track_title">
                  {page === "city"
                    ? "Follow this City"
                    : "Follow this Neighborhood"}
                </p>
                <p className="modal_track_desc">
                  Receive an email when this neighborhood has new listings,
                  <br />
                  score/ranking changes, new comments/questions, and more.
                </p>
              </div>

              <div className="ui divider divider_modal_grid"></div>

              {/* Email Input */}
              <Form.Field className="input_modal_form">
                <input
                  type="text"
                  value={subscribeemail}
                  onChange={handlesubscribeemailChange}
                  placeholder="Email"
                />
              </Form.Field>

              {/* Error / Success */}
              <FormError
                err_status={subscribeemailstatus}
                err_msg={subscribe_err_msg}
              />
              {subscribe_success_msg !== "" && (
                <p className="success_msg_uploadimg">{subscribe_success_msg}</p>
              )}
            </GridColumn>
          </GridRow>

          <div className="ui divider divider_modal_grid_caption"></div>

          {/* Submit Button */}
          <div className="caption_btn">
            <Button
              type="submit"
              primary
              style={{ marginTop: "10px", width: "100%" }}
              disabled={isLoading}
            >
              {isLoading && <Loader active inline size="tiny" />} Track
            </Button>
          </div>

          {/* Terms */}
          <div className="track_modal track_modal_terms">
            <p className="term_registration">
              By joining you agree to RYLY's{" "}
              <a href="/Terms" title="Terms">
                Terms of Use
              </a>{" "}
              and
              <a href="/Privacy-policy" title="Privacy Policy">
                {" "}
                Privacy Policy
              </a>
            </p>
          </div>
        </Grid>
      </Form>
    </ModalWrapper>
  );
}
